<script setup lang="ts">
/**
 * Closing band of /resume-examples/<slug>, after the FAQ: the related
 * examples, the hub, and the page's one offer.
 */
import { roleName, type ResumeExampleIndexItem } from '~/constants/resumeExamples'

defineProps<{ related: ResumeExampleIndexItem[] }>()

const { t, locale } = useI18n()
</script>

<template>
  <section class="sofax bg-white dark:bg-gray-950">
    <div class="section-space">
      <div class="shell">
        <div class="mx-auto max-w-3xl text-center">
          <!-- Related pages that are not written yet are left out, so the list can be empty for a while -->
          <h2 class="!text-3xl md:!text-[2.5rem]">{{ related.length ? t('resumeExamples.page.relatedTitle') : t('resumeExamples.page.moreTitle') }}</h2>
          <ul v-if="related.length" class="mt-8 flex flex-wrap justify-center gap-3">
            <li v-for="item in related" :key="item.slug">
              <LocaleLink
                :to="`/resume-examples/${item.slug}`"
                class="inline-block rounded-full bg-surface px-4 py-2 text-sm font-semibold text-ink hover:bg-accent-soft/20 dark:bg-gray-800 dark:text-white"
              >
                {{ t('resumeExamples.hub.itemLabel', { role: roleName(item, locale) }) }}
              </LocaleLink>
            </li>
          </ul>
          <p class="mt-6">
            <LocaleLink to="/resume-examples" class="link">{{ t('resumeExamples.page.hubLink') }} →</LocaleLink>
          </p>
          <p class="mt-10 text-lg">{{ t('resumeExamples.page.ctaText') }}</p>
          <div class="mt-6">
            <SofaxBtn to="/free-cv-builder" :label="t('resumeExamples.page.cta')" variant="accent" />
          </div>
          <p class="mt-6">
            <LocaleLink to="/how-to-write-a-resume" class="link">{{ t('resumeExamples.page.guideLink') }} →</LocaleLink>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>
